
/**
 * Module dependencies.
 */

import { animations } from './animations';
import { boxShadow } from './box-shadow';
import { colors } from './colors';
import { createTheme } from 'react-components/styles';
import { dimensions } from './dimensions';
import { keyframes } from './keyframes';
import { merge } from 'lodash';
import { zIndex } from './z-index';

/**
 * Export `createSlykTheme`.
 */

export function createSlykTheme(overrides: any): any {
  return createTheme(merge({}, {
    animations,
    boxShadow,
    colors,
    dimensions,
    keyframes,
    zIndex
  }, overrides));
}
